export default {"componentDescription":"","propDescriptions":{},"classDescriptions":{},"slotDescriptions":{"image":"","root":""}};